var map = {
	"./Andorra Company Formation-banner.png": 8717,
	"./Andorra Company Formation-hero.png": 1095,
	"./Andorra-la-Vella-Modern-Urban-Skyline.jpg": 7340,
	"./Canadian MSB License 1.jpg": 874,
	"./Ghana Gaming License 1.jpg": 5171,
	"./Header/arrow-down.png": 7173,
	"./Header/arrow-up.png": 7774,
	"./Header/logo.png": 7136,
	"./Home/Contact-girls.png": 4697,
	"./Home/discoverItemIcon1.svg": 4995,
	"./Home/discoverItemIcon2.svg": 4240,
	"./Home/discoverItemIcon3.svg": 193,
	"./Home/discoverItemIcon4.svg": 1694,
	"./Home/discoverItemIcon5.svg": 127,
	"./Home/discoverItemIcon6.svg": 1100,
	"./Home/home-vector-one.png": 5903,
	"./Home/house_fit.png": 5475,
	"./Home/house_full.png": 7347,
	"./Home/lake.png": 3770,
	"./Home/other-pracitces.png": 9758,
	"./Home/ruins.png": 6802,
	"./Home/whiteArrow.svg": 5275,
	"./Netherlands Company for Sale 4.jpg": 9514,
	"./Tuvalu Gaming License 3.jpg": 2855,
	"./about-us-header.png": 7989,
	"./about/SeychlessFlagIcon.svg": 2869,
	"./about/cuprysFlagIcon.svg": 526,
	"./about/gibraltarFlagIcon.svg": 370,
	"./about/girls-hidden.png": 3795,
	"./about/greeceFlagIcon.svg": 3597,
	"./about/hero-image.png": 4865,
	"./about/indonesiaFlagIcon.svg": 2388,
	"./about/isleFlagIcon.svg": 4237,
	"./about/italyFlagIcon.svg": 4975,
	"./about/luciaFlagIcon.svg": 2228,
	"./about/maltaFlagIcon.svg": 9953,
	"./about/mauritiusFlagIcon.svg": 3315,
	"./about/mwaliFlagIcon.svg": 9578,
	"./about/offshore-advisory-background.png": 4714,
	"./about/panamaFlagIcon.svg": 4160,
	"./about/singaporeFlagIcon.svg": 4392,
	"./about/spainFlagIcon.svg": 3961,
	"./about/turkeyFlagIcon.svg": 7886,
	"./about/uaeFlagIcon.svg": 7149,
	"./about/ukFlagIcon.svg": 5636,
	"./about/vector-12.png": 8986,
	"./about/vector-13.png": 4195,
	"./about/vector-14.png": 9324,
	"./about/vector-15.png": 5861,
	"./about/vector-16.png": 1854,
	"./about/vincentFlagIcon.svg": 9947,
	"./about/westernFlagIcon.svg": 8288,
	"./about/what-we-do1.png": 9557,
	"./about/what-we-do2.png": 2830,
	"./about/what-we-do3.png": 8615,
	"./about/what-we-do4.png": 6619,
	"./about/what-we-do5.png": 7393,
	"./about/who-we-are1.png": 3756,
	"./about/who-we-are2.png": 2487,
	"./about/who-we-are3.png": 8846,
	"./about/world-map.png": 2872,
	"./andorra-car-license-hero.png": 4250,
	"./andorra-license test-banner.png": 9525,
	"./area/assets-managment/banner-img.png": 6130,
	"./area/assets-managment/hero-img.png": 2152,
	"./area/fintech-hero-image.png": 1421,
	"./area/license/banner-img.png": 821,
	"./area/license/hero-img.png": 1787,
	"./area/meta-license-hero-image.png": 9739,
	"./area/ready-made-image.png": 3672,
	"./asset-protection/asset-protection.png": 7288,
	"./blackArrow.svg": 2139,
	"./brokerage-forex/malta-hero-image.png": 7499,
	"./brokerage-forex/st-lucia-hero-image.png": 8250,
	"./clientTestimonialHeader.png": 7346,
	"./clientsRecommend.png": 7609,
	"./clientsTestimonials/feauturedIcon1.svg": 8199,
	"./clientsTestimonials/feauturedIcon2.svg": 3636,
	"./clientsTestimonials/feauturedIcon3.svg": 1621,
	"./clientsTestimonials/feauturedIcon4.svg": 2522,
	"./clientsTestimonials/recommendedItemIcon1.svg": 3684,
	"./clientsTestimonials/recommendedItemIcon2.svg": 1927,
	"./clientsTestimonials/recommendedItemIcon3.svg": 5478,
	"./clientsTestimonials/recommendedItemIcon4.svg": 2361,
	"./company-formation/anajouan-formation/banner-page.jpg": 5037,
	"./company-formation/anajouan-formation/hero-image.png": 8575,
	"./company-formation/andorra-banner.png": 6351,
	"./company-formation/andorra.jpg": 3842,
	"./company-formation/anjouan-hero-image.png": 7260,
	"./company-formation/cyprus-formation/banner-image.png": 9972,
	"./company-formation/cyprus-formation/hero-image.png": 3546,
	"./company-formation/cyprus-hero-image.png": 9262,
	"./company-formation/malta-hero-image.png": 3405,
	"./company-formation/montenegro-hero-image.png": 3894,
	"./company-formation/mwali-formation/banner-image.png": 6465,
	"./company-formation/mwali-formation/hero-image.jpg": 8720,
	"./company-formation/mwali-hero-image.png": 5096,
	"./company-formation/offshore-company-formation/banner-img.png": 4492,
	"./company-formation/offshore-company-formation/hero-img.png": 2026,
	"./company-formation/uae-hero-image.png": 7753,
	"./company-formation/uk-hero-image.png": 7380,
	"./company-formation/western-sahra-formation/banner-image.png": 9352,
	"./company-formation/western-sahra-formation/hero-image.png": 2934,
	"./company-formation/western-sahra-hero-image.png": 3170,
	"./faqs-background.png": 4171,
	"./fileIcon.svg": 1274,
	"./financial-license/financial-license.png": 9986,
	"./fintech-services/fintech-services.png": 5228,
	"./footer-background.png": 2461,
	"./gaming-gamling/anjuan-gaming-gamling-hero.png": 9189,
	"./gaming-gamling/cyprus-gaming-gamling-hero.png": 5332,
	"./gaming-gamling/malta-gaming-gamling-hero.png": 8549,
	"./gaming-gamling/mwali-gaming-gamling-hero.png": 3458,
	"./globalIcon.svg": 5277,
	"./icons/adressIcon.svg": 115,
	"./icons/facebookIcon.svg": 9530,
	"./icons/instIcon.svg": 2145,
	"./icons/linkedIn.svg": 844,
	"./icons/mailIcon.svg": 8568,
	"./icons/meetIcon.svg": 672,
	"./icons/phoneIcon.svg": 8409,
	"./icons/skypeIcon.svg": 8187,
	"./icons/telegramIcon.svg": 8492,
	"./icons/whatsUpIcon.svg": 27,
	"./icons/whyContactIcon1.svg": 1780,
	"./icons/whyContactIcon2.svg": 6375,
	"./icons/whyContactIcon3.svg": 9926,
	"./icons/whyContactIcon4.svg": 6809,
	"./jurisdictions/anjouan-ju.png": 2956,
	"./jurisdictions/curacao-jurisdiction.png": 5450,
	"./jurisdictions/cyprus.png": 2000,
	"./jurisdictions/dominica-jurisdiction.png": 9776,
	"./jurisdictions/greece-jurisdiction.png": 6781,
	"./jurisdictions/indonesia-jurisdiction.png": 5618,
	"./jurisdictions/isle-of-man-jurisdiction.png": 706,
	"./jurisdictions/italy-ju.jpg": 3739,
	"./jurisdictions/malta-jurisdiction.png": 7873,
	"./jurisdictions/mauritius-jurisdiction.png": 1335,
	"./jurisdictions/mwali-jurisdiction.png": 9300,
	"./jurisdictions/panama.jpg": 3262,
	"./jurisdictions/seychelles-jurisdiction.png": 6041,
	"./jurisdictions/singapore-jurisdiction.png": 5598,
	"./jurisdictions/spain-jurisdiction.png": 5257,
	"./jurisdictions/uae-jurisdiction.png": 4165,
	"./jurisdictions/uk-jurisdiction.png": 458,
	"./jurisdictions/western-sahara-hero.png": 6826,
	"./non-dom-tax-regim/banner-img.png": 8899,
	"./non-dom-tax-regim/greece-non-dom.png": 7783,
	"./non-dom-tax-regim/italy-non-dom.png": 6191,
	"./non-dom-tax-regim/non-dom-tax-regime.png": 7009,
	"./non-dom-tax-regim/uk-non-dom.png": 6258,
	"./offshore-bank-account-opening/offshore-bank-account-opening.png": 7242,
	"./offshore-company-registration/banner-img.png": 8582,
	"./our-services/vector-1.png": 9718,
	"./our-services/vector-2.png": 1485,
	"./our-services/vector-3.png": 8244,
	"./our-services/vector-4.png": 3051,
	"./our-services/vector-5.png": 1506,
	"./our-services/vector-6.png": 9689,
	"./our-services/vector-7.png": 5488,
	"./ready-made/ready-made-western-sahara.png": 2944,
	"./real-estate/real-esate-investment-hero.png": 9607,
	"./real-estate/real-estate-investment-bali-indonesia-hero.png": 253,
	"./real-estate/real-estate-investment-cyprus-hero.png": 8430,
	"./real-estate/real-estate-investment-greece.png": 496,
	"./real-estate/real-estate-investment-italy-hero.png": 6015,
	"./real-estate/real-estate-investment-spain-hero.png": 3993,
	"./real-estate/real-estate-investment-uae-hero.png": 9797,
	"./residency-passport/gibraltar-hero.png": 4176,
	"./residency-passport/golden-visa-italy-hero.png": 7979,
	"./residency-passport/golden-visa-spain-hero.png": 6541,
	"./residency-passport/hero-img.png": 1015,
	"./residency-passport/isle-of-man-residency.png": 9608,
	"./residency-passport/residency-citizenship-dominica-hero.png": 3772,
	"./residency-passport/residency-indonesia-hero.png": 6551,
	"./residency-passport/residency-investment-cyprus-hero.png": 2027,
	"./residency-passport/residency-investment-uae-hero.png": 9022,
	"./residency-passport/residency-passport-hero.png": 8893,
	"./residency-passport/saint-lucia-citizenship.png": 1186,
	"./services/Asset Management License – Western Sahara-hero.png": 5666,
	"./services/Payments & FinTech Licenses-hero.png": 281,
	"./services/asset-management-license-mwali-hero.png": 3488,
	"./services/banking-license-hero.png": 6305,
	"./services/banking-license-in-anjouan/hero-image.png": 5976,
	"./services/banking-license/hero-image.png": 8543,
	"./services/banking-license/page-banner.png": 4291,
	"./services/brokerage-forex-license-malta-hero.png": 8248,
	"./services/brokerage-forex-licenses-hero.png": 4337,
	"./services/brokerage-license-anjouan-hero.png": 2474,
	"./services/crypto-blockchain-license-malta-hero.png": 7165,
	"./services/crypto-license-panama-hero.png": 6967,
	"./services/crypto-license-western-anjouan-hero.png": 6506,
	"./services/crypto-license-western-mwali-hero.png": 6018,
	"./services/crypto-license-western-sahara-hero.png": 6704,
	"./services/crypto-vasp-license-mauritius-hero.png": 663,
	"./services/curaçao-gaming-licens-hero.png": 790,
	"./services/forex-brokerage-St-vincent-grenadines-hero.png": 539,
	"./services/forex-brokerage-license-cyprus-hero.png": 3017,
	"./services/forex-brokerage-license-mwali-hero.png": 1129,
	"./services/forex-brokerage-license-western-sahara-hero.png": 6496,
	"./services/funds-asset-management-isle-man-hero.png": 7717,
	"./services/funds-asset-management-license-cyprus.png": 2080,
	"./services/funds-asset-management-license-malta-hero.png": 222,
	"./services/funds-asset-management-license-mauritius-hero.png": 6804,
	"./services/funds-asset-management-license-panama-hero.png": 1685,
	"./services/gaming-betting-license–cyprus-hero.png": 5837,
	"./services/gaming-betting-license–saint-lucia-hero.png": 8059,
	"./services/gaming-igaming-license-malta-hero-image.png": 8003,
	"./services/gaming-igaming-license–seychelles-hero.png": 6911,
	"./services/gaming-license-anjouan-hero.png": 289,
	"./services/gaming-license–panama.png": 7066,
	"./services/gibraltar-banking-finTech-license-hero.png": 1892,
	"./services/gibraltar-crypto-dlt-license-hero.png": 6382,
	"./services/gibraltar-funds-asset-management-license-hero.png": 4873,
	"./services/gibraltar-igaming-license-hero.png": 8676,
	"./services/insurance-captives-isle-man-hero.png": 3180,
	"./services/insurance-reinsurance-cyprus-hero.png": 7212,
	"./services/insurance-reinsurance-license-mauritius-hero.png": 1247,
	"./services/insurance-reinsurance-license-panama-hero.png": 4600,
	"./services/insurance-reinsurance-license-saint-lucia-hero.png": 1022,
	"./services/insurance-reinsurance-license-seychelles-hero.png": 4103,
	"./services/panama-gaming.png": 2556,
	"./services/panama-shipping.png": 7781,
	"./services/panama-trust.png": 3661,
	"./services/payment-services-EMI-license-cyrus-hero.png": 811,
	"./services/payment-services-EMI-license-malta-hero.png": 4484,
	"./services/payments-fintech-license-panama-hero.png": 5801,
	"./services/payments-fintech-license-seychelles-hero.png": 7538,
	"./services/securities-dealer-license-seychelles-hero.png": 6257,
	"./services/trust-insurance-licenses-anjouan-hero.jpg": 4860,
	"./services/trust-insurance-licenses-hero.jpg": 9533,
	"./services/trust-insurance-licenses-mwali-hero.jpg": 7128,
	"./services/trust-insurance-licenses-western-sahara.png": 8380,
	"./tableIcon.svg": 6878,
	"./telegramIcon.svg": 6213,
	"./whyOffshoreHeader.png": 2112
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9318;